export default from './SurveyPage';



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/index.js